import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import MLink from '@mui/material/Link';

const InlineMarkdown = (props) => {
  return (
    <ReactMarkdown
      components={{
        // eslint-disable-next-line @typescript-eslint/no-unused-vars -- destructure node to exclude from DOM props
        a: function LinkRenderer({ node, ...props }) {
          return <MLink {...props} rel="noopener noreferrer" />;
        },
      }}
      disallowedElements={['p']}
      remarkPlugins={[
        remarkGfm,
      ]}
      unwrapDisallowed
      {...props}
    />
  );
};

export default InlineMarkdown;
